import './WhatAreYouLookingFor.css';
import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import Slider from '../components/Slider';
import stopEventPropagation from '../ui_core/stopEventPropagation';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import eventEnable from '../core/eventEnable';
import Urls from '../urls/Urls';
import IconButtonNonReact from '../components/IconButtonNonReact';
export default class WhatAreYouLookingForPrice{
	constructor({siteJsons, whatAreYouLookingForViewModel, titleElement}){
		eventEnable(this);
		this._minSliderRef= React.createRef();
		this._maxSliderRef= React.createRef();
		this._whatAreYouLookingForViewModel = whatAreYouLookingForViewModel;
		this._priceRangeChanged= this._priceRangeChanged.bind(this);
		this._onSliderMinValueChanged = this._onSliderMinValueChanged.bind(this);
		this._onSliderMaxValueChanged = this._onSliderMaxValueChanged.bind(this);
		this.becomingVisible = this.becomingVisible.bind(this);
		this._handleClickButtonDone = this._handleClickButtonDone.bind(this);
		this._element = document.createElement('div');
		this._element.classList.add('price');
		this._valueElement= document.createElement('div');
		this._valueElement.classList.add('value');
		this._element.appendChild(this._valueElement);
		this._sliderMinWrapperElement = document.createElement('div');
		this._sliderMinWrapperElement.classList.add('slider-min-wrapper');
		this._sliderMaxWrapperElement = document.createElement('div');
		this._sliderMaxWrapperElement.classList.add('slider-max-wrapper');
		this._element.appendChild(this._sliderMinWrapperElement);
		
		stopEventPropagation(	this._sliderMinWrapperElement, ['click', 'mousedown', 'touchstart']);
		stopEventPropagation(	this._sliderMaxWrapperElement, ['click', 'mousedown', 'touchstart']);
		const sliderFactory = React.createFactory(Slider);
		
		ReactDOM.render(sliderFactory(
		{ 
			ref:this._minSliderRef, 
			min:siteJsons.minPlotPrice, max:siteJsons.maxPlotPrice, initial:siteJsons.minPlotPrice, 
			onValueChanged:this._onSliderMinValueChanged, 
			isHorizontal:true
		}),
		this._sliderMinWrapperElement);
		ReactDOM.render(sliderFactory(
		{ 
			ref:this._maxSliderRef, 
			min:siteJsons.minPlotPrice, max:siteJsons.maxPlotPrice, initial:siteJsons.maxPlotPrice, 
			onValueChanged:this._onSliderMaxValueChanged, 
			isHorizontal:true
		}),
		this._sliderMaxWrapperElement);
		this._minSliderRef.current.handle.element.innerHTML = 'Min';
		this._maxSliderRef.current.handle.element.innerHTML = 'Max';
		this._sliderMinWrapperElement.appendChild(this._sliderMaxWrapperElement);
		this._propertyBindingPriceRange = PropertyBindingFactory.standard(this, whatAreYouLookingForViewModel,
			'priceRange',
			this._priceRangeChanged);
		whatAreYouLookingForViewModel.priceRange = [siteJsons.minPlotPrice, siteJsons.maxPlotPrice];
		/*this._iconButtonNonReactDone = new IconButtonNonReact({
			className:'button-done',
			imgUrl:Urls.assets+'icons/tick.png', 
			onClick:this._handleClickButtonDone});
		stopEventPropagation(this._iconButtonNonReactDone.element, ['click', 'mousedown', 'touchstart']);
		titleElement.appendChild(this._iconButtonNonReactDone.element);*/
		this._firstBecomingVisible = true;
	}
	_handleClickButtonDone(){
		this.dispatchEvent({type:'chose'});
	}
	becomingVisible(){
		if(!this._firstBecomingVisible)return;
		this._firstBecomingVisible = false;
		this._minSliderRef.current.setFromInitialValue();
		this._maxSliderRef.current.setFromInitialValue();
	}
	_priceRangeChanged(value){
		if(!value)return;
		const [min, max]= value;
		this._minSliderRef.current.setValue(min);
		this._maxSliderRef.current.setValue(max);
		const noMin = (min===undefined)||(min===null);
		const noMax = (max===undefined)||(max===null);
		if((!noMin)&&(!noMax)&&(min>max)){
			this._element.classList.add('invalid');
		}
		else
			this._element.classList.remove('invalid');
	}
	_onSliderMinValueChanged(value){
		if(value===undefined||value===null)return;
		const currentPriceRange = this._propertyBindingPriceRange.get();
		this._propertyBindingPriceRange.set([value, currentPriceRange?currentPriceRange[1]:null]);
	}
	_onSliderMaxValueChanged(value){
		if(value===undefined||value===null)return;
		const currentPriceRange = this._propertyBindingPriceRange.get();
		this._propertyBindingPriceRange.set([currentPriceRange?currentPriceRange[0]:null, value]);
	}
	get element(){
		return this._element;
	}
}